import { RouteProps, Route, Router, Switch, Redirect } from 'react-router';
import { history } from '../../store';

export interface RouteWrapperPropTypes {
    routes: RouteProps[];
    initPath: string;
    matchPath: string;
}

export default function RouteWrapper({
    routes,
    initPath,
    matchPath,
    ...rest
}: RouteWrapperPropTypes) {
    return (
        <Router history={history}>
            <Switch>
                <Route
                    exact
                    path={`${matchPath}`}
                    render={(props: any) => (
                        <Redirect
                            {...props}
                            to={`${matchPath}${initPath}`}
                            from={props.location.pathname}
                        />
                    )}
                ></Route>
                {routes.map(({ path, ...route }, index) => (
                    <Route {...rest} path={`${matchPath}${path}`} key={index} {...route} />
                ))}
            </Switch>
        </Router>
    );
}
